import { useState } from "react";

// Reusable type-to-confirm modal for destructive admin actions — confirm
// stays disabled until the typed text exactly matches confirmText.
const ConfirmDestructiveModal = ({
  open,
  title,
  description,
  confirmText,
  confirmLabel = "Delete",
  busy = false,
  onConfirm,
  onCancel,
}) => {
  const [typed, setTyped] = useState("");

  if (!open) return null;

  const matches = typed === confirmText;

  const handleClose = () => {
    setTyped("");
    onCancel();
  };

  const handleConfirm = () => {
    if (!matches || busy) return;
    onConfirm();
  };

  return (
    <div className="modal modal-open">
      <div className="modal-box">
        <h3 className="text-lg font-bold text-error">{title}</h3>
        <p className="py-2 text-sm text-base-content/80">{description}</p>
        <p className="py-1 text-sm">
          Type <span className="font-mono font-bold">{confirmText}</span> to
          confirm:
        </p>
        <input
          type="text"
          className="input input-bordered w-full"
          value={typed}
          onChange={(e) => setTyped(e.target.value)}
          autoFocus
        />
        <div className="modal-action">
          <button className="btn" onClick={handleClose} disabled={busy}>
            Cancel
          </button>
          <button
            className="btn btn-error"
            disabled={!matches || busy}
            onClick={handleConfirm}
          >
            {busy ? "Working..." : confirmLabel}
          </button>
        </div>
      </div>
      <div className="modal-backdrop" onClick={handleClose}></div>
    </div>
  );
};

export default ConfirmDestructiveModal;
